import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";

@Component({
  selector: "ngx-dialog-title-prompt",
  templateUrl: "dialog-title-prompt.component.html",
  styleUrls: ["dialog-title-prompt.component.scss"],
})
export class DialogTitlePromptComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  @Input() header: string;
  @Input() description?: string;
  @Input() title: string;
  @Input() status?: string;
  @Input() privacy?: boolean;
  @Input() mode?: string;

  diaForm: FormGroup;
  submitted = false;
  user: User;
  uid = "";

  constructor(
    public userService: UserService,
    protected ref: NbDialogRef<DialogTitlePromptComponent>,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;
        } else {
          this.uid = "";
        }
      });

    const titleValidators = [
      Validators.minLength(3),
      Validators.maxLength(250),
      Validators.required,
    ];

    this.diaForm = this.fb.group({
      title: ["", titleValidators],
      status: Validators.required,
      privacy: Validators.required,
    });
    if (!this.status) {
      this.status = "0";
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancel() {
    this.ref.close();
  }

  submit() {
    this.submitted = true;
    let value = {
      title: this.title,
      status: this.status,
      privacy: this.privacy,
    };

    if (!this.user.admin && !this.user.moderator) {
      value.privacy = false;
    }

    this.ref.close(value);
  }
}
